export default __webpack_public_path__ + "static/media/check-primary.b6356d07.svg";